export default __webpack_public_path__ + "static/media/2jKMY8AFOqiToSHy1XkhiN26QCc.e8078c8d.svg";